import {REFRESH_SAMPLE_LIST} from '../actions/sampleList';
import moment from 'moment';
// let lastUpdateTime;
const initState = {
  samples: {
    data: [],
    lastUpdateTime: '2016-10-24 12:23:00'
  }
};

export default (state = initState, action) => {
  switch (action.type) {
    case REFRESH_SAMPLE_LIST: {
      const {samplesData} = action;
      const newLastUpdateTime = moment();
      return Object.assign({}, state, {
        samples: Object.assign({}, state.samples, {
          data: samplesData,
          lastUpdateTime: newLastUpdateTime
        })
      });
    }
    // case LOG_UPDATE_TIME: {
    //   const newLastUpdateTime = moment().format('YYYY-MM-DD HH-MM-SS');
    //   return Object.assign({}, state, {
    //     samples: Object.assign({}, state.samples, {
    //       lastUpdateTime: newLastUpdateTime
    //     })
    //   });
    // }
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/reducers/sampleList.js